import styled from "styled-components";

export const VouchersSwiperBox = styled.div`
    width: 100%;
    flex-shrink: 0;
    position: relative;
    padding-top: 3.3rem;
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding-top: 1.2rem;
    }

    .swiper-pagination {
        .swiper-pagination-bullet {
            background-color: white;
            opacity: 0.25;
            &.swiper-pagination-bullet-active {
                opacity: 1;
            }
        }
    }
`